import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";

export namespace AssociatePresenceValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            associateUserId: baseVals.string(),
            location: baseVals.coordinate(),
            notes: v.optional(baseVals.string()),
        }),
    );

    export namespace API {
        export const Create = defineValidation(
            v.object({
                location: baseVals.coordinate(),
                notes: v.optional(baseVals.stringEmptiable()),
            }),
        );
    }
}
